export var tala = [
    { value: "Dhruva", id: "I#-O-I#-I#" },
    { value: "Matya", id: "I#-O-I#" },
    { value: "Rupaka", id: "O-I#" },
    { value: "Jhampa", id: "I#-U-O" },
    { value: "Triputa", id: "I#-O-O" },
    { value: "Ata", id: "I#-I#-O-O" },
    { value: "Eka", id: "I#" },
    { value: "Mishra Chaapu", id: "I3-I4" },
    { value: "Kanda Chaapu", id: "I2-I3" },
    { value: "Thisra Chaapu", id: "I1-I2" },
    { value: "Sankeerna Chaapu", id: "I3-I6" },
    { value: "Viloma Chaapu", id: "I4-I3" }
];
export var jati = [
    { value: "Tisra", id: 3 },
    { value: "Chatusra", id: 4 },
    { value: "Khanda", id: 5 },
    { value: "Misra", id: 7 },
    { value: "Sankeerna", id: 9 },
];
export var nadai = [
    { value: "Single", id: 1 },
    { value: "Double", id: 2 },
    { value: "Tisra", id: 3 },
    { value: "Chatusra", id: 4 },
    { value: "Khanda", id: 5 },
    { value: "Misra", id: 7 },
    { value: "Sankeerna", id: 9 },
];
export var pitch = [
    { value: "1", id: "C" },
    { value: "1.5", id: "C#" },
    { value: "2", id: "D" },
    { value: "2.5", id: "D#" },
    { value: "3", id: "E" },
    { value: "4", id: "F" },
    { value: "4.5", id: "F#" },
    { value: "5", id: "G" },
    { value: "5.5", id: "G#" },
    { value: "6", id: "A" },
    { value: "6.5", id: "A#" },
    { value: "7", id: "B" },
];
export var noteSets = [
    { value: "P/S", id: "P/S" },
    { value: "M/S", id: "M/S" },
    { value: "Ś/S", id: "Ś/S" },
    { value: "P/N", id: "P/N" }
];
